import { render, staticRenderFns } from "./pictureLibrary.vue?vue&type=template&id=80bfea12&scoped=true"
import script from "./pictureLibrary.vue?vue&type=script&lang=js"
export * from "./pictureLibrary.vue?vue&type=script&lang=js"
import style0 from "./pictureLibrary.vue?vue&type=style&index=0&id=80bfea12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bfea12",
  null
  
)

export default component.exports